module.exports = __webpack_public_path__ + "img/shadow-mqtt.1fbed5ee.svg";